var hasOwnProperty = Object.prototype.hasOwnProperty;
function forOwn(obj, callback, context) {
  for(var prop in obj) {
    if(hasOwnProperty.call(obj, prop)) {
      var res = callback.call(context, obj[prop], prop, obj);
      if(res === false) return;
    }
  }
}

// taken from underscore, i am lazy to wrote tham myself

// Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration;
// but if you'd like to disable the execution on the leading edge, pass
// `{leading: false}`. To disable execution on the trailing edge, ditto.
exports.throttle = function(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  options || (options = {});
  var later = function() {
    previous = new Date;
    timeout = null;
    result = func.apply(context, args);
  };
  return function() {
    var now = new Date;
    if(!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if(remaining <= 0) {
      clearTimeout(timeout);
      timeout = null;
      previous = now;
      result = func.apply(context, args);
    } else if(!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
};

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
exports.debounce = function(func, wait, immediate) {
  var result;
  var timeout = null;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if(!immediate) result = func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if(callNow) result = func.apply(context, args);
    return result;
  };
};

exports.falsy = function falsy() {
  return false;
};

exports.queryString = function queryString(query) {
  var q = [];
  forOwn(query, function(value, key) {
    if(isArray(value)) {
      forOwn(value, function(v) {
        if(value != null) {
          q.push(encodeURIComponent(key) + '=' + encodeURIComponent(v));
        }
      });
    } else {
      if(value != null) {
        q.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      }
    }
  });
  return q.join('&');
};

exports.formEncodedString = function(query) {
  return exports.queryString(query).replace(/%20/g, '+')
}

exports.noop = function() {
};

exports.forOwn = forOwn;

var getPrototypeOf = exports.getPrototypeOf = Object.getPrototypeOf || (function() {
  if (typeof "test".__proto__ === "object") return function getPrototypeOfViaProto(obj) {
    return (obj != null && obj.__proto__) || null;
  };
  else return function getPrototypeOfViaConstructor(obj) {
    return (obj && obj.constructor && obj.constructor.prototype) || null;
  };
})();

var oCreate = Object.create || (function() {
    var F = function() {
    };
    return function(proto) {
      F.prototype = proto;
      var result = new F();
      F.prototype = null;
      return result;
    };
  })();

function isPlainObject(o) {
  if (!o) return false;
  var proto = getPrototypeOf(o);
  return proto === Object.prototype || proto == null;
}

exports.deepExtend = function deepExtend(out, next) {
  out = out || (isArray(next) ? [] : {});

  for(var i = 1; i < arguments.length; i++) {
    var obj = arguments[i];

    if(!obj)
      continue;

    forOwn(obj, function(value, key) {
      if (isArray(value)) {
        out[key] = deepExtend(out[key], value);
      } else if (typeof value === 'object' && value != null) {
        var proto = Object.prototype;
        if (isPlainObject(value)) {
          proto = isPlainObject(out[key]) || out[key] == null ? proto : getPrototypeOf(out[key])
        } else {
          proto = getPrototypeOf(value);
        }
        out[key] = deepExtend(oCreate(proto), out[key], value)
      } else {
        out[key] = value;
      }
    });
  }

  return out;
};

exports.inherits = function inherits(clazz, superClazz) {
  clazz.prototype = oCreate(superClazz.prototype);
};

var oToString = Object.prototype.toString;
exports.isArray = Array.isArray || isArray;
function isArray(arr) {
  return oToString.call(arr) == '[object Array]';
}

exports.forEach = exports.forOwn;

var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
var trimSupported = !!String.prototype.trim;

exports.trim = function(str) {
  return trimSupported ? str.trim() : str.replace(rtrim, '');
};

var indexOfSupported = !!Array.prototype.indexOf;

//like Array.prototype.indexOf but a bit more simple
exports.indexOf = function(arr, obj, startIndex) {
  if(indexOfSupported) return arr.indexOf(obj, startIndex);
  for(var i = startIndex || 0, l = arr.length; i < l; i++) {
    if(arr[i] === obj) return i;
  }
  return -1;
};

/**
 * A non-strict version of Object.keys
*/
exports.keys = function keys(obj) {
  obj = obj || {};
  var result = [];
  for (var key in obj) {
    if (hasOwnProperty.call(obj, key)) result.push(key);
  }
  return result;
};
